export default "__VITE_PUBLIC_ASSET__81aef92d__"